import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { CustomMediaComponent } from '@sdvor/shared/ui';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';
import { Product, ProductService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'ui-comparison-tooltip',
  imports: [SdvorIconComponent, CustomMediaComponent, AsyncPipe],
  templateUrl: './comparison-tooltip.component.html',
  styleUrls: ['./comparison-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComparisonTooltipComponent implements OnInit {
  productCode = input.required<string>();
  product$: Observable<Product>;
  iconTypes = IconTypes;

  constructor(private readonly productService: ProductService) {}

  ngOnInit(): void {
    this.product$ = this.productService.get(this.productCode());
  }
}
